import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    faExclamationTriangle as faSolidExclamationTriangle,
    faTimes as faSolidTimes,
    faPlus as faSolidPlus,
    faMinus as faSolidMinus,
    faCheck as faSolidCheck,
    faSearch as faSolidSearch,
    faExclamationCircle as faSolidExclamationCircle,
    faBars as faSolidBars,
    faCaretDown as faSolidCaretDown,
    faCircleNotch as faSolidCircleNotch,
    faArrowLeft as faSolidArrowLeft,
    faCircle as faSolidCircle,
    faLocationArrow as faSolidLocationArrow,
    faCheckCircle as faSolidCheckCircle,
    faStar as faSolidStar,
    faCreditCard as faSolidCreditCard,
    faItalic as faSolidItalic,
    faBold as faSolidBold,
    faLink as faSolidLink,
    faHorizontalRule as faSolidHorizontalRule,
    faListUl as faSolidListUl,
    faListOl as faSolidListOl,
    faQuoteLeft as faSolidQuoteLeft,
    faH3 as faSolidH3,
    faH2 as faSolidH2,
    faH1 as faSolidH1,
    faCode as faSolidCode,
    faUnderline as faSolidUnderline,
    faChevronRight as faSolidChevronRight,
} from '@fortawesome/pro-solid-svg-icons';

import {
    faUser as faLightUser,
    faShoppingCart as faLightShoppingCart,
    faSearch as faLightSearch,
    faChevronLeft as faLightChevronLeft,
    faChevronRight as faLightChevronRight,
    faChevronDown as faLightChevronDown,
    faShoppingBasket as faLightShoppingBasket,
} from '@fortawesome/pro-light-svg-icons';

import {
    faInstagram,
    faFacebookF,
    faTiktok,
    faYoutube,
    faCcAmex,
    faCcMastercard,
    faCcVisa,
    faCcDinersClub,
    faCcDiscover,
    faCcJcb,
} from '@fortawesome/free-brands-svg-icons';

import { library } from '@fortawesome/fontawesome-svg-core';

import SEO from '@components/SEO';
import Navigation from '@components/Navigation';
import Footer from '@components/Footer';

// main site style
import '@styles/style.scss';
import { Location } from '@reach/router';
import ErrorBoundary from '@components/Error/Boundary';

library.add(
    // solid icons
    faSolidBars,
    faSolidExclamationTriangle,
    faSolidTimes,
    faSolidPlus,
    faSolidMinus,
    faSolidCheck,
    faSolidSearch,
    faSolidExclamationCircle,
    faSolidCaretDown,
    faSolidCircleNotch,
    faSolidArrowLeft,
    faSolidCircle,
    faSolidLocationArrow,
    faSolidCheckCircle,
    faSolidStar,
    faSolidCreditCard,
    faSolidItalic,
    faSolidBold,
    faSolidLink,
    faSolidHorizontalRule,
    faSolidListUl,
    faSolidListOl,
    faSolidQuoteLeft,
    faSolidH3,
    faSolidH2,
    faSolidH1,
    faSolidCode,
    faSolidUnderline,
    faSolidChevronRight,

    // light icons
    faLightUser,
    faLightShoppingCart,
    faLightSearch,
    faLightChevronLeft,
    faLightChevronRight,
    faLightChevronDown,
    faLightShoppingBasket,

    // brands icons
    faInstagram,
    faFacebookF,
    faTiktok,
    faYoutube,

    faCcAmex,
    faCcMastercard,
    faCcVisa,
    faCcDinersClub,
    faCcDiscover,
    faCcJcb
);

const ScrollTop = ({ children, location: { pathname }, $elements = [] }) => {
    useEffect(() => {
        if ($elements) {
            $elements.map($element => {
                if ($element && $element.current) {
                    $element.current.scrollTo(0, 0);
                }
            });
        }
    }, [pathname]);

    return children || null;
};

const Layout = ({ children, className = '', user, location }) => {
    return (
        <div className={`app ${className}`}>
            <SEO />

            {/* Prevent navigation until a user exists and the user has selected a single website to operate and the
                user isn't on the website selection view */}
            <Navigation />

            <ScrollTop location={location}>
                <main>
                    <div>
                        <ErrorBoundary>{children}</ErrorBoundary>
                    </div>
                    <Footer />
                </main>
            </ScrollTop>
        </div>
    );
};

const LayoutWithLocation = props => (
    <Location>{locationContext => <Layout {...locationContext} {...props} />}</Location>
);

export default connect(({ user }) => ({ user }))(LayoutWithLocation);
